<template>
  <div class="mt90">
    <el-row class="pr-bgimg pr-bg-information2"></el-row>
    <el-row class="pr-container bg-white mt-160 pb-6">
      <h2 class="page-title">联系我们</h2>
      <p class="page-sub-title">Contact us</p>
      <div class="pt-5 px-5 clear mw-img100">
        <el-row class="text-center pb-5">
          <el-col :span="6">
            <el-col :span="24" class="pb-2">
              <i class="el-icon-mobile-phone font100 col999"></i>
            </el-col>
            <el-col :span="24" class="pb-2">
              <span>电话</span>
            </el-col>
            <el-col :span="24" class="pb-2 col999">18682099502</el-col>
          </el-col>
          <el-col :span="3">
            <div class="vLine"></div>
          </el-col>
          <el-col :span="6">
            <el-col :span="24" class="pb-2">
              <i class="el-icon-message font100 col999"></i>
            </el-col>
            <el-col :span="24" class="pb-2">
              <span>邮箱</span>
            </el-col>
            <el-col :span="24" class="pb-2 col999">wang.yuyu@szpuree.com</el-col>
          </el-col>
          <el-col :span="3">
            <div class="vLine"></div>
          </el-col>
          <el-col :span="6">
            <el-col :span="24" class="pb-2">
              <i class="el-icon-location font100 col999"></i>
            </el-col>
            <el-col :span="24" class="pb-2">
              <span>地址</span>
            </el-col>
            <el-col :span="24" class="pb-2 col999">深圳市罗湖区莲塘国威路68号智美国威电子商务大厦1313房</el-col>
          </el-col>
        </el-row>
        <!-- <div class="baidu text-center pt-5 pb-5" id="dituContent"></div> -->
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    // this.initMap();
  },
  methods: {
    //创建和初始化地图函数：
    initMap() {
      this.createMap(); //创建地图
      this.setMapEvent(); //设置地图事件
      this.addMapControl(); //向地图添加控件
      this.addMarker(); //向地图中添加marker
    },

    //创建地图函数：
    createMap() {
      var map = new BMap.Map("dituContent"); //在百度地图容器中创建一个地图
      var point = new BMap.Point(114.180648, 22.570363); //定义一个中心点坐标
      map.centerAndZoom(point, 18); //设定地图的中心点和坐标并将地图显示在地图容器中
      window.map = map; //将map变量存储在全局
    },

    //地图事件设置函数：
    setMapEvent() {
      map.enableDragging(); //启用地图拖拽事件，默认启用(可不写)
      map.disableScrollWheelZoom(); //禁用地图滚轮放大缩小，默认禁用(可不写)
      map.enableDoubleClickZoom(); //启用鼠标双击放大，默认启用(可不写)
      map.disableKeyboard(); //禁用键盘上下左右键移动地图，默认禁用(可不写)
    },

    //地图控件添加函数：
    addMapControl() {
      //向地图中添加缩放控件
      var ctrl_nav = new BMap.NavigationControl({
        anchor: BMAP_ANCHOR_TOP_LEFT,
        type: BMAP_NAVIGATION_CONTROL_LARGE
      });
      map.addControl(ctrl_nav);
      //向地图中添加缩略图控件
      var ctrl_ove = new BMap.OverviewMapControl({
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        isOpen: 0
      });
      map.addControl(ctrl_ove);
      //向地图中添加比例尺控件
      var ctrl_sca = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_LEFT });
      map.addControl(ctrl_sca);
    },

    //创建marker
    addMarker() {
      //标注点数组
      var markerArr = [
        {
          title: "公司地址",
          content:
            "<span class='font20'>蒲睿科技</span>",
          point: "114.179628|22.570522",
          isOpen: 1,
          icon: { w: 23, h: 25, l: 23, t: 21, x: 9, lb: 12 }
        }
      ];
      for (var i = 0; i < markerArr.length; i++) {
        var json = markerArr[i];
        var p0 = json.point.split("|")[0];
        var p1 = json.point.split("|")[1];
        var point = new BMap.Point(p0, p1);
        var iconImg = this.createIcon(json.icon);
        var marker = new BMap.Marker(point, { icon: iconImg });
        var iw = this.createInfoWindow(i);
        var label = new BMap.Label(json.title, {
          offset: new BMap.Size(json.icon.lb - json.icon.x + 10, -20)
        });
        marker.setLabel(label);
        map.addOverlay(marker);
        label.setStyle({
          borderColor: "#808080",
          color: "#333",
          cursor: "pointer"
        });
          var index = i;
          var _iw = this.createInfoWindow(i);
          var _marker = marker;
          _marker.addEventListener("click", function() {
            this.openInfoWindow(_iw);
          });
          _iw.addEventListener("open", function() {
            _marker.getLabel().hide();
          });
          _iw.addEventListener("close", function() {
            _marker.getLabel().show();
          });
          label.addEventListener("click", function() {
            _marker.openInfoWindow(_iw);
          });
          if (!!json.isOpen) {
            label.hide();
            _marker.openInfoWindow(_iw);
          }
      }
    },
    //创建InfoWindow
    createInfoWindow(i) {
      //标注点数组
      var markerArr = [
        {
          title: "",
          content:
          "<span class='font20'>蒲睿科技</span>",
          point: "114.179628|22.570522",
          isOpen: 1,
          icon: { w: 23, h: 25, l: 23, t: 21, x: 9, lb: 12 }
        }
      ];
      var json = markerArr[i];
      var iw = new BMap.InfoWindow(
        "<b class='iw_poi_title' title='" +
          json.title +
          "'>" +
          json.title +
          "</b><div class='iw_poi_content'>" +
          json.content +
          "</div>"
      );
      return iw;
    },
    //创建一个Icon
    createIcon(json) {
      var icon = new BMap.Icon(
        "http://app.baidu.com/map/images/us_mk_icon.png",
        new BMap.Size(json.w, json.h),
        {
          imageOffset: new BMap.Size(-json.l, -json.t),
          infoWindowOffset: new BMap.Size(json.lb + 5, 1),
          offset: new BMap.Size(json.x, json.h)
        }
      );
      return icon;
    }
  }
};
</script>
<style lang="scss">
.pr-bg-information2 {
  background-image: url('../../assets/images/about/1482133012276.jpg');
}
.font100 {
  font-size: 100px !important;
}
.baidu {
  height: 350px;
  border: #ccc solid 1px;
}
.vLine {
  border-left: solid 2px #ccc;
  height: 110px;
  vertical-align: middle;
  display: inline-block;
  margin-top: 15px;
}
</style>
